@switch (activeOption) {
    @case (options.PROPERTY_TYPE) {
        <property-type></property-type>
    }
    @case (options.ENERGY_LABEL) {
        <energy-label></energy-label>
    }
    @case (options.PURCHASE_PRICE) {
        <purchase-price></purchase-price>
    }
    @case (options.SUSTAINABILITY) {
        <sustainability></sustainability>
    }
    @case (options.RENOVATION) {
        <renovation-part></renovation-part>
    }
    @case (options.SUMMARY) {
        <property-type></property-type>
        <hr />
        <energy-label></energy-label>
        <hr />
        @if ((store.getProperty() | async)?.property_type !== propertyType.NONE) {
            <purchase-price></purchase-price>
            <hr />
            <sustainability></sustainability>
            <hr />
            <renovation-part></renovation-part>
            <hr />
        }
    }
}
